module.exports = __webpack_public_path__ + "images/duck_large.b467e54fde.jpg";